export default "__VITE_ASSET__c6145932__"